import { render, staticRenderFns } from "./cover-table.vue?vue&type=template&id=00e29e57"
import script from "./cover-table.vue?vue&type=script&lang=js"
export * from "./cover-table.vue?vue&type=script&lang=js"
import style0 from "./cover-table.vue?vue&type=style&index=0&id=00e29e57&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports